export default __webpack_public_path__ + "static/media/IMG_20210925_151817_993.a9449699.jpg";